import styled from "styled-components";
import {
  BoxFieldStyle,
  BoxAreaStyle,
  FieldTitleTextStyle,
} from "common/components";
import {
  fieldHeight,
  inputValidTargetAttrName,
  inputValidTargetAttrTitle,
} from "common/const/const";
import { forwardRef, useEffect, useState } from "react";

const StyledTextField = styled.input`
  width: calc(100% - 2rem);
  height: ${fieldHeight};
  padding: 0;
  margin: 0;
  border: var(--border-width) solid
    ${(props) => (props.$error ? "var(--Red)" : "var(--Gray)")};
  border-radius: var(--border-radius-8);
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;

  font-size: var(--font-size-14);
  font-weight: var(--font-weight-regular);
  color: var(--DarkNavy);

  &::placeholder {
    color: var(--LightNavy);
  }

  &:read-only {
    color: var(--DarkNavy);
    background-color: var(--White);
  }

  &:disabled {
    color: var(--Gray);
    background-color: var(--White);
  }
`;

const StyledTextArea = styled.textarea`
  width: calc(100% - 2rem);
  height: ${(props) =>
    props.$height ? props.$height : "20rem"}; // 기본값 10rem
  padding: 1rem;
  border: var(--border-width) solid
    ${(props) => (props.$error ? "var(--Red)" : "var(--Gray)")};
  border-radius: var(--border-radius-8);
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;
  font-family: var(--font-family);
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-regular);
  color: var(--DarkNavy);
`;

const StyledTitleTextField = forwardRef(
  (
    {
      title,
      placeholder,
      value,
      defaultValue,
      onClick = () => {},
      onChange = () => {},
      $isRequired,
      style,
      error,
      name,
      type,
      id,
      validType,
      validTitle,
      height,

      multiline = false,
      disabled = false,
      readOnly = false,
    },
    ref,
  ) => {
    const [isError, setIsError] = useState(true);

    useEffect(() => {
      setIsError(error);
    }, [error, setIsError]);

    return multiline ? (
      <BoxAreaStyle>
        <FieldTitleTextStyle>
          {title}
          {$isRequired && <span style={{ color: "red" }}>*</span>}
        </FieldTitleTextStyle>
        <StyledTextArea
          title={title}
          value={value}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={onChange}
          onClick={onClick}
          {...{ [inputValidTargetAttrName]: validType }}
          {...{ [inputValidTargetAttrTitle]: validTitle }}
          $height={height}
          ref={ref}
        ></StyledTextArea>
      </BoxAreaStyle>
    ) : (
      <BoxFieldStyle>
        <FieldTitleTextStyle>
          {title}
          {$isRequired && <span style={{ color: "red" }}>*</span>}
        </FieldTitleTextStyle>
        <StyledTextField
          title={title}
          name={name}
          onChange={(e) => {
            if (!e.target.value && $isRequired) {
              setIsError(true);
            } else {
              setIsError(false);
            }

            onChange(e);
          }}
          onClick={onClick}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          type={type}
          id={id}
          readOnly={readOnly}
          $multiline={multiline.toString()}
          $error={isError}
          {...style}
          {...{ [inputValidTargetAttrName]: validType }}
          {...{ [inputValidTargetAttrTitle]: validTitle }}
          ref={ref}
        />
      </BoxFieldStyle>
    );
  },
);

const StyledTitleField = ({ title, children, $isRequired }) => {
  return (
    <BoxFieldStyle>
      <FieldTitleTextStyle>
        {title}
        {$isRequired && <span style={{ color: "red" }}>*</span>}
      </FieldTitleTextStyle>
      {children}
    </BoxFieldStyle>
  );
};

export { StyledTextField, StyledTitleTextField, StyledTitleField };
